import { Controller } from "@hotwired/stimulus"

import L from "leaflet";
import "leaflet-draw"

// Connects to data-controller="territory-map"
export default class extends Controller {
  static values = {
    // Defaults to US overview
    latitude:  { type: Number, default: 40.2538 },
    longitude: { type: Number, default: -98.43 },
    zoom:      { type: Number, default: 4 },

    titleLayerURL: { type: String, default: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" },

    featureColor: { type: String, default: "#3388ff" }
  }

  connect() {
    if (this.map) return
    this.initializeMap()
    this.addFeatures()
    this.fitBounds()
  }

  disconnect() {
    if (this.map) {
      this.map.remove()
      this.map = null
    }
  }

  initializeMap() {
    this.map = L.map(this.element).setView(
      [this.latitudeValue, this.longitudeValue],
      this.zoomValue
    )

    L.tileLayer(
      this.titleLayerURLValue,
      {attribution: '&copy; OpenStreetMap contributors' }
    ).addTo(this.map)
  }

  addFeatures() {
    var features = gon.features
    var dc = this.featureColorValue;

    this.geoLayer = L.geoJSON(features, {
      style: function(feature) {
        return {
          color:     feature.properties.color || dc,
          fillColor: feature.properties.color || dc,
          weight: 1.5,
          fillOpacity: 0.25
        };
      },
      onEachFeature: function(feature, layer) {
        if (feature.properties) {
          layer.bindPopup(
            `<strong>${feature.properties.territory}</strong><br/>${feature.properties.segments}`
          );
        }
      }
    }).addTo(this.map);
  }

  fitBounds() {
    if (gon.features.length > 0) {
      this.map.fitBounds(this.geoLayer.getBounds());
    }
  }
}
